import { render, staticRenderFns } from "./JobListItemDueTime.vue?vue&type=template&id=940df70a&"
import script from "./JobListItemDueTime.vue?vue&type=script&lang=js&"
export * from "./JobListItemDueTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports